import { render, staticRenderFns } from "./dashboard_ecar.vue?vue&type=template&id=5a42991e&scoped=true&"
import script from "./dashboard_ecar.vue?vue&type=script&lang=js&"
export * from "./dashboard_ecar.vue?vue&type=script&lang=js&"
import style0 from "./dashboard_ecar.vue?vue&type=style&index=0&id=5a42991e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a42991e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
